<dialog-container>
	<create-performer (performerCreated)="closeDialog($event)"></create-performer>
</dialog-container>
